import loadable from '@loadable/component';

export default loadable(
  () => import(/* webpackChunkName: "convSearchListing.m" */ './ConvSearch')
);
